module.exports = __webpack_public_path__ + "static/media/journey_sl_active.7e44e2b4.png";